<template>
  <main>
    <app-header type="title" title="등록"></app-header>
    <section class="l-container">
      <div class="store-select-wrap">
        <strong class="astar">
          매장
        </strong>
        <span>스탬프 카드 신청 매장</span>
        <div class="store-select">
          <select name="store">
            <option value="default" selected>매장선택</option>
            <option value="option1">매장1</option>
            <option value="option2">매장2</option>
          </select>
        </div>
      </div>
      <div class="regist-list">
        <ul>
          <!-- 스탬프기본정보 -->
          <li>
            <div class="list-title" @click="defaultInfo = !defaultInfo" :class="{'is-show': defaultInfo}">
              <span>스탬프 기본정보</span>
            </div>
            <div v-show="defaultInfo" class="list-content">
              <div class="section-area">
                <strong class="astar">카드명</strong>
                <input class="input-area" type="text" placeholder="카드 이름을 입력하세요.">
              </div>
              <div class="section-area">
                <strong class="astar">적립수</strong>
                <span class="sub">스탬프 카드에 적립 가능한 총 개수</span>
                <div class="count-wrap">
                  <div class="count-area">
                    <span class="mius"></span>
                    <input type="number" v-model="countNum" disabled>
                    <span class="plus"></span>
                  </div>
                </div>
              </div>
              <div class="section-area">
                <strong class="astar">안내</strong>
                <div class="textarea">
                  <textarea placeholder="고객에게 보여질 스탬프 카드 설명을 입력하세요."></textarea>
                </div>
              </div>
              <div class="section-area">
                <strong>쿠폰이미지</strong>
                <span class="sub color-red">미선택시 기본이미지가 표시</span>
                <ul class="img-list">
                  <li>
                    <div class="img-box">
                      <img src="../assets/images/coupon-img.png" alt="">
                    </div>
                    <p>쿠폰 이미지</p>
                  </li>
                  <li>
                    <div class="img-box">
                      <img src="../assets/images/coupon-img.png" alt="">
                    </div>
                    <p>쿠폰 상세 이미지</p>
                  </li>
                  <li>
                    <div class="img-box">
                      <img src="../assets/images/coupon-img.png" alt="">
                    </div>
                    <p>쿠폰 ON 이미지</p>
                  </li>
                  <li>
                    <div class="img-box">
                      <img src="../assets/images/coupon-img.png" alt="">
                    </div>
                    <p>쿠폰 OFF 이미지</p>
                  </li>
                </ul>
              </div>
              <div class="section-area">
                <strong class="astar">운영기간</strong>
                <input class="input-area" type="text" placeholder="종료일자 설정하기">
                <sub class="sub-txt">선택한 날짜까지 스탬프카드가 운영됩니다.</sub>
              </div>
            </div>
          </li>
          <!-- 쿠폰정보 -->
          <li>
            <div class="list-title" @click="couponInfo = !couponInfo" :class="{'is-show': couponInfo}">
              <span>쿠폰정보</span>
            </div>
            <div v-show="couponInfo" class="list-content">
              <ul class="coupon-list">
                <li v-for="(coupon, index) in 2" :key="coupon.key">
                  <p class="coupon-name">쿠폰정보 {{ index+1 }}</p>
                  <div class="section-area">
                    <strong class="astar">쿠폰명</strong>
                    <input class="input-area" type="text" placeholder="쿠폰 이름을 입력하세요.">
                  </div>
                  <div class="section-area">
                    <strong class="astar">발행위치</strong>
                    <div class="count-wrap">
                      <div class="count-area">
                        <span class="mius"></span>
                        <input type="number" v-model="countNum" disabled>
                        <span class="plus"></span>
                      </div>
                    </div>
                    <sub class="sub-txt">스탬프 카드를 몇개 찍었을 때 쿠폰을 발행할<br/>것인지 선택할 수 있습니다.</sub>
                  </div>
                  <div class="section-area">
                    <strong class="astar">발급기간</strong>
                    <div class="input-group">
                      <input class="input-area start-date" type="text" placeholder="발급시작날짜">
                      <span>~</span>
                      <input class="input-area end-date" type="text" placeholder="발급종료날짜">
                    </div>
                  </div>
                  <div class="section-area">
                    <strong class="astar">만료기간</strong>
                    <input class="input-area" type="text" placeholder="만료기간 설정하기">
                  </div>
                  <div class="section-area">
                    <strong>쿠폰이미지</strong>
                    <span class="sub color-red">미선택시 기본이미지가 표시</span>
                    <ul class="img-list">
                      <li>
                        <div class="img-box">
                          <img src="../assets/images/coupon-img.png" alt="">
                        </div>
                        <p>쿠폰 이미지</p>
                      </li>
                      <li>
                        <div class="img-box">
                          <img src="../assets/images/coupon-img.png" alt="">
                        </div>
                        <p>쿠폰 상세 이미지</p>
                      </li>
                      <li>
                        <div class="img-box">
                          <img src="../assets/images/coupon-img.png" alt="">
                        </div>
                        <p>쿠폰 ON 이미지</p>
                      </li>
                      <li>
                        <div class="img-box">
                          <img src="../assets/images/coupon-img.png" alt="">
                        </div>
                        <p>쿠폰 OFF 이미지</p>
                      </li>
                    </ul>
                  </div>
                  <div class="btn-group">
                    <div class="btn btn-line">
                      <span>쿠폰 삭제</span>
                    </div>
                    <div class="btn btn-line-blue">
                      <span>쿠폰 추가</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <!-- 스탬프 정보 -->
          <li>
            <div class="list-title" @click="stampInfo = !stampInfo" :class="{'is-show': stampInfo}">
              <span>스탬프 정보</span>
            </div>
            <div v-show="stampInfo" class="list-content">
              <div class="section-area">
                <div class="card-mid">
                  <div class="label-txt">
                    <span>스탬프번호</span>
                    <p class="txt">V00A078B001M00013P0001FSC001</p>
                  </div>
                  <div class="label-txt">
                    <span>등록자</span>
                    <p class="txt">admin</p>
                  </div>
                  <div class="label-txt">
                    <span>등록일자</span>
                    <p class="txt">2019.10.12  15:00:00</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="btn-group btn-bottom">
        <div class="btn btn-left btn-half">
          <span>취소</span>
        </div>
        <div class="btn btn-right btn-half">
          <span>등록</span>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import AppHeader from '../components/AppHeader.vue'
export default {
  name: 'Regist',
  components: {
    AppHeader
  },
  data () {
    return {
      countNum: 0,
      defaultInfo: false,
      couponInfo: false,
      stampInfo: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Regist.vue